import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import gtm from '@/utils/gtm';
import { Navigation, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const A: React.FC<{ type: string }> = ({ type }) => {
    const { t } = useLang('business');
    const { t: s } = useLang('business.A');
    const swiperRef = useRef<any>(null);
    // const [selectIndex, setSelectIndex] = useState(1);
    const onTabChange = (newType: string) => {
        const item = list.filter((item, index) => {
            return item.type === newType;
        });

        const index = item[0].key;
        // if (index === selectIndex) {
        //     return;
        // }
        // setSelectIndex(index - 1);
        swiperRef.current?.slideTo(index - 1);
    };
    useEffect(() => {
        setTimeout(() => {
            onTabChange(type);
        }, 100);
    }, [type]);
    const list = [
        {
            title: s('title_4'),
            desc: s('desc_4'),
            btn: s('btn'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1767092831533/homebc-home-carousel-banner-PC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1767149149875/home-home-carousel-banner-mob.jpg',
            pc_webp: 'https://websiteoss.ecoflow.com/upload/image/1767092831533/homebc-home-carousel-banner-PC.jpg',
            h5_webp: 'https://websiteoss.ecoflow.com/upload/image/1767149149875/home-home-carousel-banner-mob.jpg',
            color: '#000',
            key: 1,
            type: t('tab_title_4'),
        },
        {
            title: s('title_2'),
            desc: s('desc_2'),
            btn: s('btn'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766374913750/1-pc-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1766374913550/1-h5-2.jpg',
            pc_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738310032/1-pc-2.webp',
            h5_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738310475/1-h5-2.webp',
            color: '#fff',
            key: 2,
            type: t('tab_title_2'),
        },

        {
            title: s('title_1'),
            desc: s('desc_1'),
            btn: s('btn'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766374912466/1-pc-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1767149149717/home-carousel-banner-pps-mob.jpg',
            pc_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738310660/1-pc-1.webp',
            h5_webp: 'https://websiteoss.ecoflow.com/upload/image/1767149149717/home-carousel-banner-pps-mob.jpg',
            color: '#000',
            key: 3,
            type: t('tab_title_1'),
        },
        {
            title: s('title_3'),
            desc: s('desc_3'),
            btn: s('btn'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766374914168/1-pc-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1766374913367/1-h5-3.jpg',
            pc_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738309844/1-pc-3.webp',
            h5_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738310841/1-h5-3.webp',
            color: '#fff',
            key: 4,
            type: t('tab_title_3'),
        },
        {
            title: s('title_5'),
            desc: s('desc_5'),
            btn: s('btn'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766374913064/1-pc-5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1767149150061/oasis-home-carousel-banner-mob.jpg',
            pc_webp: 'https://websiteoss.ecoflow.com/upload/image/1766738309645/1-pc-5.webp',
            h5_webp: 'https://websiteoss.ecoflow.com/upload/image/1767149150061/oasis-home-carousel-banner-mob.jpg',
            color: '#fff',
            key: 5,
            type: t('tab_title_5'),
        },
    ];

    return (
        <section className={`${css.section} business-A GtmModuleData-section`} id="business-A" data-section-id={'business-A'} data-section-title={t('title')}>
            <Swiper
                modules={[EffectFade]}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                effect={'fade'}
                speed={600}
                centeredSlides={true}
                slidesPerView={'auto'}
                // allowTouchMove={false} // 🚫 禁止触摸滑动
                // simulateTouch={false} // 🚫 禁止鼠标拖动
                keyboard={{ enabled: false }} // 🚫 禁止键盘操作
                mousewheel={false} // 🚫 禁止滚轮操作
            >
                {list.map((item: any, index: number) => (
                    <SwiperSlide key={index + 1} className="swiper-slide">
                        <div className="img pc">
                            <picture>
                                <source srcSet={item?.pc_webp} type="image/webp" />
                                <img fetchpriority="high" loading="eager" src={item?.pc} alt={t('title')} width="100%" height="100%" />
                            </picture>
                        </div>
                        <div className="img h5">
                            <picture>
                                <source srcSet={item?.h5_webp} type="image/webp" />
                                <img fetchpriority="high" loading="eager" src={item?.h5} alt={t('title')} width="100%" height="100%" />
                            </picture>
                        </div>
                        <div className={`info info-${item?.key}`} style={{ color: item?.color }}>
                            <div className={`inner`}>
                                <div className={`title`}>{item?.title}</div>
                                <p className={`desc`}>{item?.desc}</p>
                                <div
                                    className={`btn GtmModuleData-btn-common`}
                                    data-btn-id={t('title')}
                                    onClick={() => {
                                        const rect = document?.getElementById?.('business-I')?.getBoundingClientRect();
                                        if (rect) {
                                            // 减掉顶部遮挡
                                            const topH = window.innerWidth > 1024 ? 130 : 80;
                                            const top = rect.top + window.pageYOffset - topH;
                                            window.scrollTo({
                                                top: top,
                                                behavior: 'smooth',
                                            });
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'click_anchor',
                                                position: item?.title,
                                                button_name: item?.btn,
                                                __btn_id1: `info .btn`,
                                                __btn_id2: item?.btn,
                                                __btn_type: 'common',
                                            });
                                        }
                                    }}
                                >
                                    {item?.btn}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default A;
